import { motion } from 'framer-motion';
import { Youtube, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      data-testid="footer-section"
      className="py-12 bg-void-black border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo/Brand */}
          <motion.div 
            className="text-center md:text-left"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <h3 className="font-syne font-extrabold text-2xl tracking-tighter uppercase">
              <span className="text-neon-red">Shadowcell</span> Studios
            </h3>
            <p className="font-manrope text-neutral-500 text-sm mt-1">
              Featuring Roxxie Vayne
            </p>
          </motion.div>

          {/* Social Links */}
          <motion.div 
            className="flex items-center gap-6"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <a
              href="https://www.youtube.com/@hypnoticvocals"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-youtube"
              className="social-icon text-neutral-400"
              aria-label="YouTube"
            >
              <Youtube className="w-6 h-6" />
            </a>
            <a
              href="https://x.com/Hypnoticvocals"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-twitter"
              className="social-icon text-neutral-400"
              aria-label="X (Twitter)"
            >
              <Twitter className="w-6 h-6" />
            </a>
          </motion.div>

          {/* Copyright */}
          <motion.p 
            className="font-manrope text-neutral-500 text-sm text-center md:text-right"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            © {currentYear} Shadowcell Studios. All rights reserved.
          </motion.p>
        </div>

        {/* Bottom Tagline */}
        <motion.div 
          className="mt-12 pt-8 border-t border-white/5 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <p className="font-manrope text-neutral-600 text-xs tracking-widest uppercase">
            Cinematic AI Videos • Powered by Passion
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
